import React from "react";
import { useNavigate } from "react-router";
import { Button } from "@/shared/components/ui/button";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { useAppContext } from "@/shared/hooks/useAppContext";
import { POST_LOSS_ROUTES, ONBOARDING_ROUTES } from "@/shared/constants/paths";
import { ArrowRight } from "lucide-react";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { authUser } = useAppContext();

  const handleGoHome = () => {
    navigate(authUser ? POST_LOSS_ROUTES.OVERVIEW : ONBOARDING_ROUTES.ACCOUNT);
  };

  return (
    <FullscreenLayout>
      <div className="flex flex-col items-center justify-center text-center">
        <h1>Page Not Found</h1>
        <p className="text-base max-w-md mt-4">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 mt-8">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button variant="brand" onClick={handleGoHome}>
            {authUser ? "Go to Dashboard" : "Go to Home"}
            <ArrowRight size={16} />
          </Button>
        </div>
      </div>
    </FullscreenLayout>
  );
};

export default NotFoundPage;
